import { render, staticRenderFns } from "./BizEnterprisePensionModal.vue?vue&type=template&id=b3cd4b62&"
import script from "./BizEnterprisePensionModal.vue?vue&type=script&lang=js&"
export * from "./BizEnterprisePensionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports